import { z } from 'zod';

const InitialPublicOfferItem = z.object({
  id: z.string().nullable(),
  instrumentIsin: z.string().nullable(),
  instrumentTitle: z.string().nullable(),
  allowingSubmittingPreOrderUntilDateTime: z.string(),
  price: z.number().nullable(),
  quantity: z.number().nullable(),
  submitDate: z.string().nullable(),
  state: z.string(),
  stateName: z.string().nullable(),
  sectorCode: z.string().nullable(),
  subSectorCode: z.string().nullable(),
  instrumentType: z.string().nullable(),
  isAutomaticSubmit: z.boolean(),
  hasPreOrder: z.boolean(),
  maximumOrderPrice: z.number(),
  minimumOrderPrice: z.number(),
  maximumOrderQuantity: z.number(),
  minimumOrderQuantity: z.number(),
  startDate: z.string(),
  endDate: z.string(),
  isUnderwriting: z.boolean(),
  isForTest: z.boolean(),
  description: z.string().nullable(),
});

const CreateInitialPublicOffer = z.object({
  quantity: z.number(),
  price: z.number(),
  instrumentIsin: z.string(),
  orderExecutionType: z.string(),
});

const UpdateInitialPublicOffer = z.object({
  orderId: z.number(),
  quantity: z.number(),
  price: z.onumber(),
  orderExecutionType: z.string(),
});

const InitialPublicOffer = InitialPublicOfferItem.array().nullable();

const CreatePreInitialPublicOffer = z.object({
  instrumentIsin: z.string(),
  quantity: z.number(),
  price: z.number(),
  orderExecutionType: z.string(),
});

type InitialPublicOfferItem = z.infer<typeof InitialPublicOfferItem>;
type InitialPublicOffer = z.infer<typeof InitialPublicOffer>;
type CreateInitialPublicOffer = z.infer<typeof CreateInitialPublicOffer>;
type UpdateInitialPublicOffer = z.infer<typeof UpdateInitialPublicOffer>;
type CreatePreInitialPublicOffer = z.infer<typeof CreatePreInitialPublicOffer>;

export {
  InitialPublicOfferItem,
  InitialPublicOffer,
  CreateInitialPublicOffer,
  UpdateInitialPublicOffer,
  CreatePreInitialPublicOffer,
};
